export const parentTeacherConferenceTableAdditionalColumnsKeys = {
    parentCount: 'parentCount',
} as const;
